import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components/dc-icon';

export enum ActionIcons {
	Add = 'action:add',
	AddExpositionAccess = 'action:exposition-add-access',
	ActivateElement = 'action:element-activate',
	ActivateExposition = 'action:exposition-activate',
	Automatic = 'action:automatic-assign',
	AutoMap = 'action:auto-map',
	ColumnExpositionChooser = 'action:exposition-column-chooser',
	CreateDepotFromConnector = 'action:depot-create-from-element',
	CreateFromDatablock = 'action:datablock-create-from-element',
	CreateEntityFromDepot = 'action:depot-create-entity',
	DeactivateElement = 'action:element-deactivate',
	DeActivateExposition = 'action:exposition-deactivate',
	DeleteExpositionData = 'action:exposition-delete-data',
	Delete = 'action:delete',
	DeleteElement = 'action:delete-element',
	DuplicateElement = 'action:duplicate-element',
	EditDatablock = 'action:datablock-edit-element',
	EditExpositionColumns = 'action:exposition-edit-columns',
	ExportDatablock = 'action:datablock-export-element',
	Filter = 'action:apply-filtering',
	FilterOff = 'action:filter-off',
	FilterWarning = 'action:filter-duplicates',
	Input = 'action:input',
	Import = 'action:import',
	Mapper = 'action:mapper',
	PersistInDisk = 'action:persist-disk',
	Publish = 'action:publish',
	PublishExposition = 'action:exposition-publish',
	ResetSelection = 'action:reset-selection',
	Share = 'action:share',
	ShareOff = 'action:share-off',
	Output = 'action:output',
	UnPersist = 'action:unpersist',
	Update = 'action:update',
	UpdateExpositionData = 'action:exposition-update-data',
}

@Injectable()
export class AppActionsIcons extends AppIcons {
	private readonly path = './src/img';
	protected namespace = 'action';
	protected icons: IIcons = {
		[ActionIcons.Add]: `${this.path}/common/add_circle_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.AddExpositionAccess]: `${this.path}/common/add_circle_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.ActivateElement]: `${this.path}/common/flash_on_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.ActivateExposition]: `${this.path}/common/share_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Automatic]: `${this.path}/common/rotate_auto_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.AutoMap]: `${this.path}/common/wand_stars_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.ColumnExpositionChooser]: `${this.path}/common/splitscreen_vertical_add_24dp_FILL0_wght0_GRAD0_opsz24.svg`,
		[ActionIcons.CreateDepotFromConnector]: `${this.path}/connector/dc-depot.svg`,
		[ActionIcons.CreateFromDatablock]: `${this.path}/datablock/dc-datablock.svg`,
		[ActionIcons.CreateEntityFromDepot]: `${this.path}/depot/dc-entity.svg`,
		[ActionIcons.DeactivateElement]: `${this.path}/common/flash_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.DeActivateExposition]: `${this.path}/common/share_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Delete]: `${this.path}/common/delete_FILL0_wght400_GRAD0_opsz24.svg`,
		[ActionIcons.DeleteExpositionData]: `${this.path}/common/output_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.DeleteElement]: `${this.path}/common/delete_forever_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.DuplicateElement]: `${this.path}/common/file_copy_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.EditDatablock]: `${this.path}/common/edit_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.EditExpositionColumns]: `${this.path}/common/edit_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.ExportDatablock]: `${this.path}/datablock/upload_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.Filter]: `${this.path}/common/filter_alt_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.FilterOff]: `${this.path}/common/filter_alt_off_48dp.svg`,
		[ActionIcons.FilterWarning]: `${this.path}/common/filter_warning_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Input]: `${this.path}/common/input_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Import]: `${this.path}/project/download_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.Mapper]: `${this.path}/common/rotate_auto_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.PersistInDisk]: `${this.path}/datablock/disc-drive-light.svg`,
		[ActionIcons.Publish]: `${this.path}/common/publish_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.PublishExposition]: `${this.path}/common/publish_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Share]: `${this.path}/common/share_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.ShareOff]: `${this.path}/common/share_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Output]: `${this.path}/common/output_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.ResetSelection]: `${this.path}/common/reset_settings_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.UnPersist]: `${this.path}/datablock/disc-drive-light-off.svg`,
		[ActionIcons.Update]: `${this.path}/common/edit_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.UpdateExpositionData]: `${this.path}/common/input_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
	};
}
